import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { jsx as _jsx } from "react/jsx-runtime";
const EventBasedEnrollmentAnalysisDetails = ({
  diagnosisReason,
  selectedEnrollment
}) => {
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: diagnosisReason.reason === 'EVENT_ENROLL' ? 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.EVENT_ENROLL_jsx' : 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.EVENT_RE_ENROLL_jsx',
      elements: {
        ObjectNameLabel,
        ObjectTypeLabel,
        b: 'b'
      },
      options: {
        objectName: {
          portalId: selectedEnrollment.portalId,
          objectTypeId: selectedEnrollment.objectTypeId,
          objectId: selectedEnrollment.objectId,
          showId: getIsInternal()
        }
      }
    })
  });
};
export default EventBasedEnrollmentAnalysisDetails;